var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"management-page management-form-page",attrs:{"padding":""}},[_c('ImportForm',{on:{"import":_vm.onImport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }